export default __webpack_public_path__ + "static/media/Solid Waste.fd7e8409.svg";